<template>
  <FormInputSelectWidget
    :id="inputId"
    :notRequired="notRequired"
    :label="label" :hideLabel="hideLabel"
    :hasError="hasError" :errorMsg="errorMsg"
    appendText="%" :appendAction="appendAction"
    :prependText="prependText" :prependAction="prependAction"
    :options="dilazioneOptions"
    :value="value"
    @input="emitInput"
  >
    <template v-if="$slots.label" #label="{ label, notRequired }">
      <slot name="label" :label="label" :notRequired="notRequired" />
    </template>

    <template v-if="hasAppendSlot" #append><slot name="append"></slot></template>
    <template v-if="hasAppendContentSlot" #append-content><slot name="append-content"></slot></template>
    <template v-if="hasPrependSlot" #prepend><slot name="prepend"></slot></template>
    <template v-if="hasPrependContentSlot" #prepend-content><slot name="prepend-content"></slot></template>
  </FormInputSelectWidget>
</template>

<script>

import formInputWidgetMixin from '../../../../../libs/Form/components/Inputs/mixins/formInputWidget';
import formSelectPropsMixin from '../../../../../libs/Form/components/Inputs/mixins/formSelectProps';

export default {
  mixins: [formInputWidgetMixin, formSelectPropsMixin],
  components: {
    FormInputSelectWidget: () => import('../../../../../libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
  },
  data () {
    return {
      dilazioneOptions: [
        { value: 0, label: '0 giorni' },
        { value: 1, label: '30 giorni' },
        { value: 2, label: '60 giorni' },
        { value: 3, label: '90 giorni' },
        { value: 4, label: '120 giorni' },
        { value: 5, label: '150 giorni' },
        { value: 6, label: '180 giorni' },
      ],
    };
  },
};

</script>
